import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { FloorType } from 'src/app/services/portal-api.service';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';

@Component({
  selector: 'app-floor-dropdown',
  standalone: true,
  imports: [ClickOutsideDirective, CommonModule, TranslocoPipe],
  templateUrl: './floor-dropdown.component.html',
  styleUrl: './floor-dropdown.component.css'
})
export class FloorDropdownComponent implements OnChanges {
  @Input() dropdownItems: IFloorDropdownItem[] = [];
  @Input() title: string | undefined;
  @Input() floor: number | undefined;
  @Input() floorType: FloorType | undefined;
  @Output() onFloorSelected: EventEmitter<IFloorDropdownItem> = new EventEmitter<IFloorDropdownItem>();

  public selectedItem: IFloorDropdownItem | undefined;
  public showResults = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.floorType != null && this.floor != null) {
      this.selectedItem = this.dropdownItems.find(x => x.floorType === this.floorType && x.floor === this.floor)
    } else if (this.floor != null) {
      this.selectedItem = this.dropdownItems.find(x => x.floor === this.floor);
    }
  }

  public toggleDropdown() {
    this.showResults = !this.showResults;
  }

  public closeDropdown() {
    this.showResults = false;
  }

  public onFloorSelect(item: IFloorDropdownItem) {
    if (item.disabled === true) {
      return;
    }
    this.selectedItem = item;
    this.onFloorSelected.emit(item);
    this.closeDropdown();
  }



}

export interface IFloorDropdownItem {
  key: FloorDropdownItemKey,
  floor: number,
  floorType?: FloorType,
  disabled: boolean
}

export enum FloorDropdownItemKey {
  Basement = 'Basement',
  SemiBasement = 'SemiBasement',
  GroundFloor = 'GroundFloor',
  FirstFloor = 'FirstFloor',
  SecondFloor = 'SecondFloor',
  ThirdFloor = 'ThirdFloor',
  FourthPlusFloor = 'FourthPlusFloor'
}